import { useMutation } from 'react-query';

import { getAiRiskSummary as mutationFn } from 'api/endPoints/getAiRiskSummary';

export const useMutationGenerateRiskSummaryMitigation = () => {
    return useMutation<
        {
            mitigation: string;
            taskId: number;
        },
        QueryError,
        {
            taskId: number;
            laneId: string | number;
            isVirtual: boolean;
            cardId: number | null;
            versionId: number;
        }
    >((params) => mutationFn(params));
};
